import React, { useEffect } from "react";
import AppRoutes from "./data/app-routes";
import { LanguageProvider } from "./context/language-context";
import { Provider } from "react-redux";
import store from "./state/store";
import { AppProvider, UserProvider } from "./context";

const App: React.FC = () => {
  // useEffect(() => {
  //   if (
  //     StoreUtil.get(SESSION_ISUSERLOOGED_KEY) !==
  //     aesEncryptDecrypt.encodeBase64("true").toString()
  //   ) {
  //     StoreUtil.removeAllCookies();
  //   }
  // }, []);

  return (
    <>
      <LanguageProvider>
        <Provider store={store}>
          <AppProvider>
            <UserProvider>
              {/* <WindowPerformer> */}
                <AppRoutes></AppRoutes>
              {/* </WindowPerformer> */}
            </UserProvider>
          </AppProvider>
        </Provider>
      </LanguageProvider>
    </>
  );
};

export default App;
